export const ORG_UI_CONFIG_CACHE_KEY = 'orgUiConfig'
export const ORG_UI_CONFIG_CACHE_TTL = 60 * 60 * 1000
export const ORG_UI_CONFIG_UPDATED_EVENT = 'orgUiConfigUpdated'

function getLocalStorage() {
  try {
    if (typeof window === 'undefined') return null
    return window.localStorage || null
  } catch (_) {
    return null
  }
}

function notifyOrgUiConfigUpdated(data) {
  try {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return
    const event = typeof window.CustomEvent === 'function'
      ? new window.CustomEvent(ORG_UI_CONFIG_UPDATED_EVENT, { detail: data || null })
      : null
    if (event) window.dispatchEvent(event)
  } catch (_) {}
}

export function readOrgUiConfigCache() {
  const storage = getLocalStorage()
  if (!storage) return null

  let raw = ''
  try {
    raw = storage.getItem(ORG_UI_CONFIG_CACHE_KEY)
  } catch (_) {
    return null
  }
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') {
      clearOrgUiConfigCache()
      return null
    }

    const hasWrappedData = Object.prototype.hasOwnProperty.call(parsed, 'data')
    if (!hasWrappedData) {
      clearOrgUiConfigCache()
      return null
    }

    const savedAt = Number(parsed.savedAt || 0)
    const ttl = Number(parsed.ttl || ORG_UI_CONFIG_CACHE_TTL)
    if (!parsed.data || !savedAt || Date.now() - savedAt >= ttl) {
      clearOrgUiConfigCache()
      return null
    }

    return parsed.data
  } catch (_) {
    clearOrgUiConfigCache()
    return null
  }
}

export function writeOrgUiConfigCache(data) {
  const storage = getLocalStorage()
  if (!storage || !data) return

  try {
    storage.setItem(ORG_UI_CONFIG_CACHE_KEY, JSON.stringify({
      data,
      savedAt: Date.now(),
      ttl: ORG_UI_CONFIG_CACHE_TTL
    }))
    notifyOrgUiConfigUpdated(data)
  } catch (_) {}
}

export function clearOrgUiConfigCache() {
  const storage = getLocalStorage()
  if (!storage) return

  try {
    storage.removeItem(ORG_UI_CONFIG_CACHE_KEY)
    notifyOrgUiConfigUpdated(null)
  } catch (_) {}
}
